import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FloatingLabelInput as Input } from '../';
import '../CardField/placeholder.scss';
import moment from 'moment';

export default class DateTime extends React.Component {
  static propTypes = {
    dateOnly: PropTypes.bool,
    dateLabel: PropTypes.string,
    fluid: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string,
    timeZone: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    width: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      date: this.formattedInput(),
      dateOnly: this.props.dateOnly
    };
    this.getClass = this.getClass.bind(this);
    this.onChange = this.onChange.bind(this);
    this.formattedInput = this.formattedInput.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateOnly !== this.props.dateOnly ||
      nextProps.timeZone !== this.props.timeZone) {
      // We must set the new value before changing the field type
      // See https://github.com/sankalpk/cloverbook-rails/issues/57
      this.setState({ date: this.formattedInput(nextProps) }, () => {
        this.setState({ dateOnly: nextProps.dateOnly });
      });
      // Propagate changes to HOC so desktop datepicker component updates
      this.props.onChange({
        target: { value: this.formattedInput(nextProps) }
      });
    }
  }

  onChange(e) {
    this.props.onChange(e);
    this.setState({ date: e.target.value });
  }

  getClass() {
    return this.props.value === '' ? '' : 'hasValue';
  }

  formattedInput(props = this.props) {
    const timeZone = props.timeZone || moment.tz.guess();
    if (moment(props.value).isValid()) {
      if (props.dateOnly) {
        return moment(props.value).format('YYYY-MM-DD');
      }
      return moment
        .tz(props.value, timeZone)
        .format('YYYY-MM-DDTHH:mm');
    }
    return '';
  }

  render() {
    const inputType = this.state.dateOnly ? 'date' : 'datetime-local';
    const rest = _.omit(this.props, ['onChange', 'value', 'width', 'dateLabel']);
    const inputWidth = this.props.width || '145px';

    return (
      <Input
        type={inputType}
        label={this.props.dateLabel}
        inputRef={e => {
          const input = e;
          if (input) {
            input.className = this.getClass();
            input.style = Object.assign({}, input.style, {
              border: 'none',
              height: '1em',
              background: 'transparent',
              width: '100%',
              padding: '0.5em 0'
            });
          }
        }}
        onChange={this.onChange}
        value={this.state.date}
        width={this.props.fluid ? '100%' : inputWidth}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Elements/FloatingLabelInput/FloatingLabelDateTime.js